import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import {
  CreateUserCohortDto,
  UserCohortDto,
} from '../../../models/user-cohort/dto/user-cohort.dto';
import { GET_COHORTS_QUERY_KEY } from './useGetCohorts';

export function useCreateCohort() {
  const queryClient = useQueryClient();
  const apiClient = useApiClient();

  return useMutation({
    mutationFn: async (dto: CreateUserCohortDto) => {
      const response = await apiClient.fetchApi<
        UserCohortDto,
        CreateUserCohortDto
      >({
        method: 'POST',
        endpoint: 'cohorts',
        body: dto,
      });
      return response;
    },
    onSuccess: (data) => {
      // Invalidate cohorts list for this organization
      queryClient.invalidateQueries({
        queryKey: GET_COHORTS_QUERY_KEY(data.organizationId),
      });
    },
  });
}
